// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91ecb006","977":"ddd7f71d"}[chunkId] + ".chunk.js";
};